<lib-teeth [currentTeeth]="teeth()" />
